module.exports = __webpack_public_path__ + "img/clean.6e015f0d.png";